import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {
  Q9HtmlDecoderPipe,
  Q9TrackDirective,
  Q9TransformPipe,
  Q9TrimValueDirective
} from '@q9elements/ui-kit/common';

import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  IconButtonComponent,
  PrimaryButtonComponent,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {TextToHtmlPipe} from '../../pipes/text-to-html.pipe';
import {AiChatDialogComponent} from './ai-chat-dialog.component';
import {ErrorComponent} from './components/error/error.component';
import {HistoryComponent} from './components/history/history.component';
import {ImageComponent} from './components/image/image.component';
import {InputComponent} from './components/input/input.component';
import {MessageComponent} from './components/message/message.component';

@NgModule({
  declarations: [
    AiChatDialogComponent,
    ErrorComponent,
    MessageComponent,
    ImageComponent,
    HistoryComponent,
    InputComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    TextToHtmlPipe,
    MatTabsModule,
    Q9TrimValueDirective,
    Q9TransformPipe,
    MatTooltipModule,
    MatSidenavModule,
    MatRippleModule,
    Q9TrackDirective,
    DialogCloseButtonComponent,
    PrimaryButtonComponent,
    IconButtonComponent,
    DialogCloseButtonComponent,
    TextFieldComponent,
    ContentLoaderComponent,
    TextareaFieldComponent,
    Q9HtmlDecoderPipe,
    Q9TrimValueDirective,
    Q9TrimValueDirective
  ]
})
export class AiChatDialogModule {}
